import { render, staticRenderFns } from "./addbranch.vue?vue&type=template&id=087b787c&scoped=true&"
import script from "./addbranch.js?vue&type=script&lang=js&"
export * from "./addbranch.js?vue&type=script&lang=js&"
import style0 from "./addbranch.vue?vue&type=style&index=0&id=087b787c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087b787c",
  null
  
)

export default component.exports